/* eslint-disable react-hooks/rules-of-hooks */
import { useFieldValue } from "formik";
import { useAvailableTreatments } from "../hooks/useAvailableTreatments";
import { FlexContext } from "../models/flexible/flex-context";
import { FlexFieldController } from "../models/flexible/flex-field-controller";
import { FlexSectionController } from "../models/flexible/flex-section-controller";
import { FlexSectionSchema } from "../models/flexible/flex-section-schema";

export class SupportingItemSectionController implements FlexSectionController {
	context: FlexContext = {} as any;

	constructor(
		readonly schema: FlexSectionSchema,
		readonly path: string,
		readonly fieldControllers: Array<FlexFieldController>,
		readonly sectionControllers: Array<FlexSectionController>
	) {}

	useCanAddItem(): boolean {
		const treatments = useAvailableTreatments(this);
		const selectableTreatmentLength = treatments.filter((t) => !t.canBeMain).length;
		const selectedItems = useFieldValue(this.path);
		return selectedItems.length < selectableTreatmentLength;
	}
}
